import apiService from '../../../services/api';
import { DemoResponse } from '../model/DemoModel';

export const heroApi = {
  getDemos: async (): Promise<DemoResponse> => {
    
      const res = await apiService.get('/branding/demos');
      return res.data;
  },

  openDemoVideo: (videoUrl: string): void => {
    window.open(videoUrl, '_blank', 'noopener,noreferrer');
  }
};